import { forwardRef, Inject, Pipe, PipeTransform } from '@angular/core';
import { DataExportState } from '../../model';
import { StatusTagPipe } from './status-tag.pipe';

@Pipe({ name: 'dataExportState', pure: false })
export class DataExportStatePipe implements PipeTransform {

    constructor(
        @Inject(forwardRef(() => StatusTagPipe)) private statusTagPipe: StatusTagPipe
    ) {
    }

    transform(value: DataExportState): string {
        switch (value) {
            case DataExportState.COMPLETED:
                return this.statusTagPipe.transform(value, { icon: null, iconStyle: null, color: '#3D7300', backgroundColor: '#7AE50026' });
            case DataExportState.ERROR:
                return this.statusTagPipe.transform(value, { icon: null, iconStyle: null, color: '#7C0505', backgroundColor: '#F80A0A26' });
            default:
                return this.statusTagPipe.transform(value, { icon: null, iconStyle: null, color: '#212121', backgroundColor: '#42424226' });
        }
    }
}

